import { Layout } from '@/components/forms/fields/types';
import { makeLayoutOptionalExcept } from '@/components/forms/field.schema';
import { labelFields } from './labels.fields';

// Destructure fields for readability and type safety
const { name, description, color, tickets, lists, deleted, created, modified } =
  labelFields;

// Define the layout object for the label form
export const labelDetailLayout = {
  '': {
    name,
    description,
    color,
  },
  Settings: {
    tickets,
    lists,
  },
  Metadata: {
    created,
    modified,
    deleted,
  },
} satisfies Layout;

export const createLabelDetailLayout = makeLayoutOptionalExcept(
  labelDetailLayout,
  ['name', 'tickets', 'lists'],
);
